export default __webpack_public_path__ + "static/media/ECW-Phone.392c7820.webp";